import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { InputAttributeNode as IInputAttributeNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { getAttributeNodeIcon } from '../BaseNode/helpers';
import { useAppSelector } from '~/store/reduxHooks';
import { selectHasInputAttributeNodeFolder } from 'flow/store/redux/selectors';
import { selectCustomTransactionAttributesEnabled } from '~/dashboard/views/workflows/store/redux/selectors/general';


function InputAttributeNode(props: WorkflowNodeProps<IInputAttributeNode>) {
  const { id, type, data: { isPublishedAttribute, label, objectType } } = props;

  const isChildNode = useAppSelector(selectHasInputAttributeNodeFolder);
  const customTransactionAttributesEnabled = useAppSelector(
    selectCustomTransactionAttributesEnabled,
  );

  const iconName = getAttributeNodeIcon({
    defaultIcon: IconName.Input,
    isPublishedAttribute,
    objectType,
    customTransactionAttributesEnabled,
  });

  return (
    <BaseNode
      icon={
        <Icon icon={iconName} size="large" />
      }
      id={id}
      isChildNode={isChildNode}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-juicyBlue-100)',
        hovered: {
          backgroundColor: 'var(--cl-juicyBlue-200)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(InputAttributeNode);
